import dompurify from 'dompurify';

import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog';
import {
	Drawer,
	DrawerContent,
	DrawerDescription,
	DrawerHeader,
	DrawerTitle,
} from '@/components/ui/drawer';
import { useIsBreakpoint } from '@/hooks/use-is-breakpoint';
import { sanitizeOptions } from '@/utils';

interface PhiloModalProps {
	philoModalActive: boolean;
	currentPhilo: Discipline;
	closeEvent(): void;
}

const PhiloModal = ({ philoModalActive, currentPhilo, closeEvent }: PhiloModalProps) => {
	const isMobile = useIsBreakpoint('max', 768);
	const sanitizer = dompurify.sanitize;

	const handleOpenChange = (open: boolean) => {
		if (!open) closeEvent();
	};

	const title = `${currentPhilo?.name} Philosophy`;

	const richTextContent = (
		<div
			className="text-(--header-text) [&_ol]:list-none [&_ol]:m-0 [&_ol]:counter-reset-[listCounter] [&_ul]:m-0 [&_li:not([class])]:relative [&_li:not([class])]:counter-increment-[listCounter] [&_li:not([class])]:before:content-[counter(listCounter)'.'] [&_li:not([class])]:before:mr-2 [&_.ql-indent-1]:list-[circle] [&_.ql-indent-1]:ml-10 [&_.ql-indent-2]:list-[circle] [&_.ql-indent-2]:ml-12"
			dangerouslySetInnerHTML={{
				__html: sanitizer(currentPhilo?.philosophy, {
					...sanitizeOptions,
				}),
			}}
		/>
	);

	if (isMobile) {
		return (
			<Drawer open={philoModalActive} onOpenChange={handleOpenChange}>
				<DrawerContent className="max-h-[85vh]">
					<DrawerHeader>
						<DrawerTitle>{title}</DrawerTitle>
						<DrawerDescription className="sr-only">
							View the discipline philosophy below.
						</DrawerDescription>
					</DrawerHeader>
					<div className="px-4 pb-4 flex-1 overflow-y-auto">{richTextContent}</div>
				</DrawerContent>
			</Drawer>
		);
	}

	return (
		<Dialog open={philoModalActive} onOpenChange={handleOpenChange}>
			<DialogContent className="max-w-[800px]">
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
					<DialogDescription className="sr-only">
						View the discipline philosophy below.
					</DialogDescription>
				</DialogHeader>
				<div className="max-h-[70vh] overflow-y-auto pr-1">{richTextContent}</div>
			</DialogContent>
		</Dialog>
	);
};

export default PhiloModal;
